import React from "react";
import { Box, Typography } from "@mui/material";
import InviteButton from "./InviteButton/InviteButton";
import { faCopy, faCheck } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import {
  handleWhatsappClick,
  handleEmailClick,
} from "./utils/inviteMessageUtils";
import { useTranslation } from "react-i18next";

const InviteActions = ({
  isCopied, // Indica se o link já foi copiado (para mostrar o ícone de check)
  isCodeCopied, // Indica se o código foi copiado (caso use código em vez de link)
  onCopy, // Função que copia o link
  className = "",
  style = {},
  value, // Valor do convite (link ou código)
  type, // Tipo do convite (usado para definir a mensagem)
}) => {
  const { t } = useTranslation();

  //Função come estilo base dos botões
  const buttonBaseStyle = {
    fontSize: { sm: "0.7rem", md: "0.9rem" },
    minWidth: "190px",
    width: { xs: "100%", sm: "48%", md: "230px" },
    maxWidth: "230px",
    height: "45px",
    background: "#F9FAFC",
  };

  return (
    <Box sx={{ marginTop: "30px" }}>
      <Typography
        sx={{
          color: "#666666",
          "@media (max-width:740px)": {
            textAlign: "center",
          },
        }}
      >
        {t("inviteUsers.what_do_you_want_to_do")}
      </Typography>
      <Box
        sx={{
          marginTop: "15px",
          display: "flex",
          flexDirection: "row",
          gap: 1,
          justifyContent: { xs: "center", sm: "flex-start" },
          "@media (max-width:740px)": {
            flexDirection: "column",
            alignItems: "center",
          },
        }}
      >
        <InviteButton
          isCopied={isCopied}
          isCodeCopied={isCodeCopied}
          onClick={onCopy}
          text={type === "link" ?  t("inviteUsers.copy_link") :  t("inviteUsers.copy_code") }
          copiedText={t("inviteUsers.copied")}
          className={`${className} blue`}
          sx={{
            ...buttonBaseStyle,
            borderColor: "#1976d2",
            color: "#1976d2",
            "&:hover": {
              background: "#d6ecfd",
            },
          }}
          icon={faCopy}
          iconActive={faCheck}
        />

        <InviteButton
          onClick={() => handleWhatsappClick(value, type)}
          text={t("inviteUsers.send_on_whatsapp")}
          className={`${className} blue`}
          sx={{
            ...buttonBaseStyle,
            borderColor: " #00A055",
            color: "#00A055",
            "&:hover": {
              background: "#05a05834",
            },
          }}
          icon={faWhatsapp}
        />

        <InviteButton
          onClick={() => handleEmailClick(value, type)}
          text={t("inviteUsers.send_by_email")}
          className={`${className} blue`}
          sx={{
            ...buttonBaseStyle,
            borderColor: " #662D91",
            color: "#662D91",
            "&:hover": {
              background: "#E1DAE6",
            },
          }}
          icon={faEnvelope}
        />
      </Box>
    </Box>
  );
};

export default InviteActions;
